import React from 'react';

import style from './ConicDiagram.scss';

export const ConicDiagram = ({ value = 0, title = '', className = '' }) => {
    const remaining = 100 - value;
    const degree = remaining * 3.6;
    const additionalClass = remaining > 50 ? style.donutBig : '';

    return (
        <div className={`${style.container} ${className}`}>
            <div className={`${style.donut} ${additionalClass}`}>
                <div className={style.progressBar} style={{ transform: `rotate(${degree}deg)` }} />
                <div className={style.value}>{title}</div>
            </div>
        </div>
    );
};

